import { AuthState } from '../../../types/AuthTypes';

const initialState: AuthState = {
  user: {},
  impacter: {
    fetching: false,
    data: null,
  },
  impacterTerms: {
    updated: null,
    slug: null,
  },
};

export default initialState;
